<ng-container *ngIf="devLocal">
  <h1>Iniciar sesión</h1>

  <form [formGroup]="formLogin" (ngSubmit)="submit()">
    <div class="col-4">
      <label for="input-username">Email</label>
      <div class="input-group mb-0">
        <input id="input-username" formControlName="username" type="text" class="form-control select_criterios" placeholder="Ej. A.CAMPOS" aria-describedby="basic-addon2">
      </div>
      
      <input [disabled]="formLogin.invalid" type="submit" class="btn btn-primary" value="Aceptar">
    </div>
  </form>

  <table class="table table-striped mt-2">
    <thead>
      <th>Usuario</th>
      <th>Tipo</th>
      <th>Acceso rápido</th>
    </thead>
    <tbody>
      <tr>
        <td>emaliqueo@duoc.cl</td>
        <td>Administrativo</td>
        <td><p class="btn btn-dark" (click)="accesoRapidoUsr('emaliqueo@duoc.cl')"><i class="bi bi-key-fill"></i></p></td>
      </tr>
      <tr>
        <td>csagaceta_axity@externos.duoc.cl</td>
        <td>Administrativo</td>
        <td><p class="btn btn-dark" (click)="accesoRapidoUsr('csagaceta_axity@externos.duoc.cl')"><i class="bi bi-key-fill"></i></p></td>
      </tr>
      <tr>
        <td>csandoval_axity@externos.duoc.cl</td>
        <td>Administrativo</td>
        <td><p class="btn btn-dark" (click)="accesoRapidoUsr('csandoval_axity@externos.duoc.cl')"><i class="bi bi-key-fill"></i></p></td>
      </tr>
      <tr>
        <td>pr.carreno@profesor.duoc.cl</td>
        <td>Docente</td>
        <td><p class="btn btn-dark" (click)="accesoRapidoUsr('pr.carreno@profesor.duoc.cl')"><i class="bi bi-key-fill"></i></p></td>
      </tr>
      <tr>
        <td>docentetest_3@profesor.duoc.cl</td>
        <td>Docente</td>
        <td><p class="btn btn-dark" (click)="accesoRapidoUsr('docentetest_3@profesor.duoc.cl')"><i class="bi bi-key-fill"></i></p></td>
      </tr>
      <tr>
        <td>ma.olhagaray@profesor.duoc.cl</td>
        <td>Docente</td>
        <td><p class="btn btn-dark" (click)="accesoRapidoUsr('ma.olhagaray@profesor.duoc.cl')"><i class="bi bi-key-fill"></i></p></td>
      </tr>
      <tr>
        <td>ju.venegasr@profesor.duoc.cl</td>
        <td>Docente</td>
        <td><p class="btn btn-dark" (click)="accesoRapidoUsr('ju.venegasr@profesor.duoc.cl')"><i class="bi bi-key-fill"></i></p></td>
      </tr>
    </tbody>
  </table>
</ng-container>